<template>
  <div class="product">
    <div class="product-heading">
      <h1 class="title">
        <img
          src="../../assets/images/_parts/other/logo.svg"
          alt="Find My SKINCARE"
        />
      </h1>
      <p class="subtitle">スキンケア商品検索チャート</p>
      <p class="desc">
        商品カテゴリーやブランドから商品を絞り込んで、<br />複数のスキンケア商品からあなたにピッタリな商品を見つけよう。
      </p>
    </div>
    <steps :step="2" />
    <div class="contents">
      <Step2 :items="itemArray" ref="step2" />
      <!-- <div class="product-link"> -->
      <next-button
        class="nextButton"
        :isActive="isNextButtonActive"
        @clickButton="handleClickCompare"
        >商品を一覧で見る</next-button
      >
      <BackButton class="back-button" @clickButton="$router.push('/')" />
      <SearchIcon class="searchIcon" :number="itemArray.length" />
      <!-- </div> -->
    </div>
    <picture class="product-banner">
      <a href="/sp/cms/onlineshop/campaign/i/sample/">
        <img
          src="../../assets/images/bnr_fms.jpg"
          alt="スキンケアお探しの方におすすめ！ワタシプラス限定 スキンケアサンプルお試しサービス 12/31まで"
        />
      </a>
    </picture>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Step2 from "../model/productSelect/Step2.vue";
import SearchIcon from "../model/common/SearchIcon.vue";
import { withinPriceRange } from "../../modules/withinPriceRange";
import BackButton from "../model/common/BackButton.vue";
import NextButton from "../model/common/NextButton.vue";
import { adobeClickEvent } from "../../modules/analytics";
import Steps from "../model/common/Steps.vue";
export default {
  name: "ProductSelect",
  components: { Step2, SearchIcon, BackButton, NextButton, Steps },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters("selectedFormIds", [
      "selectedLists",
      "selectedCategory",
      "isListChecked",
    ]),
    ...mapGetters("product", ["selectedProductIds"]),
    ...mapGetters("jsonData", ["tables", "forms"]),
    itemArray() {
      const categoryFilteredItems = this.filterCategory(this.items);
      return this.filterItem(categoryFilteredItems);
    },
    isNextButtonActive() {
      return this.selectedProductIds.length !== 0;
    },
  },
  methods: {
    removeSelectedItem(janCode) {
      this.$store.dispatch("product/removeSelectedProductIds", {
        value: janCode,
      });
    },
    /**
     * 商品の配列を条件でフィルタリングした結果を返す
     */
    filterItem(itemArray) {
      const { brand_names, kinou_search, price_range, seibun, worries_some } =
        this.selectedLists;
      let filteredItem = [];
      filteredItem = this.matchFilter(
        brand_names,
        itemArray,
        "brand_name",
        "brand_names"
      );
      filteredItem = this.matchFilter(
        worries_some,
        filteredItem,
        "worries_some"
      );
      filteredItem = this.matchFilter(
        kinou_search,
        filteredItem,
        "kinou_search"
      );
      filteredItem = this.matchFilter(seibun, filteredItem, "seibun");
      filteredItem = this.priceRangeFilter(price_range, filteredItem);
      return filteredItem;
    },

    /**
     * 商品カテゴリーでフィルタリングする
     */
    filterCategory(itemArray) {
      const categoryID =
        this.forms.bigan_names[this.selectedCategory].values[0];
      return itemArray.filter((item) => {
        let isMatched = false;
        isMatched = item.bigan_name === categoryID;

        if (!isMatched) this.removeSelectedItem(item.jan_code);
        return isMatched;
      });
    },

    /**
     * マッチするかどうかの条件でフィルタリングする
     * @param {array} condition 条件の値が入った配列
     * @param {array} targetArray フィルタリングをかける商品の配列
     * @param { string } targetKey 商品オブジェクトの中でフィルタリングに使うkeyの名前
     * @param { string } tableKey テーブルオブジェクトの中でフィルタリングに使うkeyの名前
     */
    matchFilter(condition, targetArray, targetKey, tableKey = targetKey) {
      if (condition.length === 0) return targetArray;
      const formData = this.forms[tableKey];
      const conditionValues = condition.flatMap((key) => formData[key].values);
      const newConditionValues = [...new Set(conditionValues)]; // 重複をなくす

      return targetArray.filter((item) => {
        const testValue = item[targetKey];
        let isMatched = false;
        if (Array.isArray(testValue)) {
          isMatched = testValue.some((value) =>
            newConditionValues.includes(value)
          );
        } else {
          isMatched = newConditionValues.includes(testValue);
        }

        // filterによって外される場合はチェックボックスのチェックを消す
        if (!isMatched) this.removeSelectedItem(item.jan_code);

        return isMatched;
      });
    },

    /**
     * 値の幅に収まっているかどうかの条件でフィルタリングする
     * @param {array} condition 条件の値が入った配列
     * @param {array} targetArray フィルタリングをかける商品の配列
     */
    priceRangeFilter(condition, targetArray) {
      if (condition.length === 0) return targetArray;

      const formData = this.forms["price_range"];
      const conditionValues = condition.flatMap((key) => formData[key].values);
      const newConditionValues = [...new Set(conditionValues)];

      /**
       * @type { [number, number][] } 価格の数字の下限と上限が入った配列
       */
      const matchedConditions = newConditionValues.map((key) => {
        return this.tables.price_range[key];
      });

      const matchedItems = targetArray.filter((target) => {
        const targetPrice = target.komi_kkk;

        // memo: １つでも条件に引っかかっていればsomeでtrueが返る
        const isWithinRange = matchedConditions.some((priceRangeArray) => {
          const isInRange = withinPriceRange(priceRangeArray, targetPrice);
          return isInRange;
        });

        // filterによって外される場合はチェックボックスのチェックを消す
        if (!isWithinRange) this.removeSelectedItem(target.jan_code);

        return isWithinRange;
      });
      return matchedItems;
    },
    analyze(eventId) {
      adobeClickEvent(`step2_${eventId}`);
    },
    handleClickCompare() {
      if (!this.isNextButtonActive) return;
      this.analyze("confirm");
      this.$router.push("/comparison");
    },
    checkAll() {
      this.$refs.step2.checkAllBox();
    },
  },
  mounted() {},
  created() {
    // this.$store.dispatch("product/setFixedId", { value: "" });
  },
};
</script>

<style lang="scss" scoped>
.product {
  padding: 40px 0;
  &-heading {
    @include media() {
      padding: 0 20px;
    }
  }

  .title {
    width: 560px;
    margin: 0 auto 0;
    position: relative;
    left: -15px;
  }

  .subtitle {
    font-size: 20px;
    font-weight: 600;
    margin-top: 18px;
    letter-spacing: 6px;
    text-align: center;
  }

  .desc {
    letter-spacing: 1.3px;
    margin-top: 17px;
    text-align: center;
    letter-spacing: 1px;
  }
  .contents {
    margin-top: 100px;
    padding-bottom: 20px;
  }
  &-link {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    position: sticky;
    left: 0;
    bottom: 20px;
    @include media() {
      margin-top: vw(20);
      bottom: vw(20);
    }
  }

  .searchIcon {
    margin-top: -100px;
    margin-left: auto;
    margin-right: 20px;
    position: sticky;
    right: 0;
    bottom: 30px;
  }

  .nextButton {
    margin-top: 40px;
    margin-left: auto;
    margin-right: auto;
    position: sticky;
    left: 0;
    bottom: 40px;
  }

  .back-button {
    margin-top: -60px;
    margin-left: 20px;
    position: sticky;
    bottom: 30px;
  }

  .product-banner {
    max-width: 500px;
    margin: 60px auto;

    a {
      display: inline-block;
    }
  }

  @include media() {
    padding: vw(16) 0 vw(40);
    .title {
      width: 100%;
      left: auto;
    }

    .subtitle {
      font-size: vw(16);
      margin-top: vw(8);
      letter-spacing: vw(1.6);
    }

    .desc {
      font-size: vw(10);
      letter-spacing: initial;
      margin-top: vw(7);
      text-align: left;
      line-height: 1.6;
    }
    .contents {
      margin-top: 0;
    }
    .searchIcon {
      margin-top: vw(-65);
      margin-right: vw(15);
      bottom: vw(45);
    }
    .nextButton {
      margin-top: vw(80);
      bottom: vw(20);
    }

    .back-button {
      margin-top: vw(-100);
      margin-left: vw(15);
      bottom: vw(50);
    }

    .product-banner {
      width: 100%;
      max-width: none;
      margin: 0 auto ;
      text-align: center;
      a {
        display: block;
        margin: vw(40) auto 0;
      }
      img {
        display: inline-block;
        max-width: vw(250);
      }
    }
  }
}
</style>
